var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 77,
    viewBox: "0 0 54 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4028 4.6155C50.1235 5.00172 50.5714 5.86242 50.5714 7.09778V46.571C50.5714 48.9934 48.8495 51.9387 46.7252 53.1499L12.1097 72.8865C11.0476 73.4921 10.0861 73.5494 9.39009 73.1526L1.69775 68.7667C2.39377 69.1635 3.35531 69.1062 4.41741 68.5006L39.0329 48.764C41.1571 47.5528 42.8791 44.6074 42.8791 42.1851V2.71187C42.8791 1.47651 42.4312 0.615803 41.7105 0.229584L49.4028 4.6155Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39026 73.1524C8.69424 72.7556 8.26375 71.9046 8.26375 70.6934V31.2202C8.26375 28.7979 9.98573 25.8524 12.1099 24.6413L46.7254 4.90469C47.7663 4.31122 48.7106 4.24429 49.403 4.61536L41.7107 0.229447C41.0182 -0.141626 40.074 -0.0746974 39.0331 0.518776L4.41758 20.2554C2.2934 21.4665 0.571411 24.412 0.571411 26.8343V66.3075C0.571411 67.5187 1.00191 68.3697 1.69793 68.7665L9.39026 73.1524Z",
    fill: "url(#paint0_linear_113_203898)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddii_113_203898)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7016,
    height: 48.2451,
    rx: 4.3859,
    transform: "matrix(0.868715 -0.495312 0 1 8.12146 26.7549)",
    fill: "#70B7DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddiiii_113_203898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7624 55.5697L21.7624 51.2743L29.6663 38.8767C30.2589 37.9275 30.7632 37.0809 31.1794 36.3369C31.5956 35.5848 31.913 34.889 32.1317 34.2495C32.3504 33.602 32.4597 32.9725 32.4597 32.3612C32.4597 31.6775 32.3292 31.1687 32.0682 30.8349C31.8072 30.493 31.4475 30.3201 30.9889 30.316C30.5304 30.312 30.0049 30.4789 29.4124 30.8168C28.8128 31.1586 28.2873 31.599 27.8358 32.138C27.3844 32.6689 27.0317 33.2681 26.7777 33.9358C26.5308 34.5994 26.4074 35.3053 26.4074 36.0533L21.4449 38.8828C21.4449 37.2016 21.7765 35.5606 22.4396 33.9599C23.1026 32.3592 24.0338 30.8871 25.2329 29.5438C26.4392 28.1884 27.8394 27.0563 29.4336 26.1473C31.0771 25.2102 32.5056 24.7095 33.7188 24.6451C34.9321 24.5808 35.8703 24.9226 36.5334 25.6707C37.2035 26.4067 37.5386 27.5147 37.5386 28.9948C37.5386 29.936 37.3728 30.9636 37.0412 32.0776C36.7097 33.1917 36.1136 34.5532 35.2531 36.1619C34.3995 37.7667 33.1863 39.7977 31.6132 42.2551L29.0209 46.4601L29.0209 46.6169L37.8031 41.6096L37.8031 46.4239L21.7624 55.5697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddii_113_203898",
    x: 5.4607,
    y: 1.63444,
    width: 48.1615,
    height: 74.8957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.88692,
    dy: 0.88692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.153
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.88692,
    dy: -0.88692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.88692
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_113_203898",
    result: "effect2_dropShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.88692,
    dy: 0.88692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.88692
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_113_203898",
    result: "effect3_dropShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_113_203898",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.177384,
    dy: -0.177384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.177384
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.177384,
    dy: 0.177384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.177384
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_113_203898",
    result: "effect5_innerShadow_113_203898"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddiiii_113_203898",
    x: 20.5678,
    y: 23.7603,
    width: 18.1125,
    height: 32.6866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0487318,
    dy: -0.0487318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0487318
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0487318,
    dy: 0.0487318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0487318
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_113_203898",
    result: "effect2_dropShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_113_203898",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.877173,
    dy: 0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.877173,
    dy: -0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_113_203898",
    result: "effect4_innerShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.877173,
    dy: -0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_113_203898",
    result: "effect5_innerShadow_113_203898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.877173,
    dy: 0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_113_203898",
    result: "effect6_innerShadow_113_203898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_203898",
    x1: 5.15125,
    y1: 73.2476,
    x2: 2.76683,
    y2: 2.91642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#71B8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AED6EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.503665bb08135d3f9536cd1735ae8811.svg";
export { ForwardRef as ReactComponent };